export default "__VITE_ASSET__DNT5GoVT__"